import CurrencyView from '@app/components/price/currency-view.tsx';
import PrimaryButton from '@app/components/primary-button.tsx';
import { useProductPicker } from '@app/page/online-order/product-picker/logic/use-product-picker.ts';
import { MenuItemFragment } from '@app/graphql/types/graphql.ts';
import SecondaryButton from '@app/components/secondary-button.tsx';
import { calculateTotal } from '@app/page/online-order/product-picker/logic/calculate-total.tsx';
import DialogButton from '@app/components/dialog-button.tsx';
import Cart from '@app/page/online-order/product-picker/component/cart.tsx';
import { useTranslate } from '@tolgee/react';
import LeftModalButton from './left-modal-button';

const CartBar = (props: { menu: MenuItemFragment; onCreate?: () => void; disableOrderButton?: boolean }) => {
  const { menu, onCreate } = props;
  const { t } = useTranslate();

  const pickedProducts = useProductPicker((state) => state.products);

  // Calculate total
  const total = calculateTotal(pickedProducts, menu);
  //calculate quantity
  const quantity = pickedProducts.reduce((acc, pickedProduct) => acc + pickedProduct.quantity, 0);

  return (
    <div className="cart-bar">
      <div className="cart-bar__content">
        <div className="cart-bar__item">
          <LeftModalButton
            title={t('online-order.picker-page.cart.header', 'Cart')}
            content={<Cart menu={menu} onCreate={onCreate} disableOrderButton={props.disableOrderButton} />}
          >
            <SecondaryButton className="cart-bar__view-cart-btn">{quantity} product(s)</SecondaryButton>
          </LeftModalButton>
        </div>
        <div className="cart-bar__spacer" />
        <div className="cart-bar__item">
          <CurrencyView price={total} className="cart-bar__total" />
        </div>
        <div className="cart-bar__item">
          <DialogButton>
            <PrimaryButton className="cart-bar__checkout-btn" onClick={props.onCreate} disabled={props.disableOrderButton}>
              {t('online-order.picker-page.cart.button.checkout', 'Checkout')}
            </PrimaryButton>
          </DialogButton>
        </div>
      </div>
    </div>
  );
};

export default CartBar;
